import { GraphObject, Group, InputEvent, Link } from 'gojs';
import { highlightAncestors, highlightGroupTree, highlightPredecessors } from '../../../utils/highlight-utils';

export const mouseHover = (e: InputEvent, link: GraphObject) => {
  (link as Link).isHighlighted = true;
  const node = e.diagram.findNodeForKey((link as Link).data.to) || e.diagram.findNodeForKey((link as Link).data.from);

  if (node instanceof Group) {
    highlightGroupTree(node as Group);
  } else {
    if (node) {
      highlightPredecessors(node);
      highlightAncestors(node);
    }
  }
};

export const mouseLeave = (e: InputEvent, _link: GraphObject) => {
  e.diagram.clearHighlighteds();
};
